var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDiscord = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 40,
    viewBox: "0 0 52 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5592 3.3374C40.1774 1.75824 36.6202 0.618641 32.9513 0C32.4887 0.830281 31.9623 1.9536 31.5954 2.849C27.7031 2.26292 23.7312 2.26292 19.8389 2.849C19.4242 1.8722 18.9616 0.927961 18.4511 0C14.7822 0.634921 11.209 1.75824 7.82722 3.35368C1.12747 13.545 -0.691037 23.4921 0.218215 33.2926C4.14236 36.2719 8.54505 38.5348 13.2349 40C14.2877 38.5348 15.2289 37.0045 16.0264 35.3765C14.511 34.7904 13.0435 34.0741 11.6397 33.2438C12.0066 32.967 12.3575 32.674 12.6925 32.3972C20.9396 36.3696 30.4947 36.3696 38.7258 32.3972C39.0768 32.6903 39.4437 32.9833 39.7946 33.2438C38.3908 34.0904 36.9233 34.8067 35.3919 35.3928C36.1895 37.0045 37.1307 38.5511 38.1835 40C42.8733 38.5511 47.276 36.2882 51.2001 33.2926C52.253 21.9455 49.3657 12.0798 43.5433 3.35368L43.5592 3.3374ZM17.159 27.269C14.6227 27.269 12.533 24.8921 12.533 21.978C12.533 19.0639 14.5748 16.6707 17.159 16.6707C19.7432 16.6707 21.801 19.0476 21.785 21.9617C21.7691 24.8759 19.7432 27.269 17.159 27.269ZM34.2434 27.269C31.707 27.269 29.6174 24.8921 29.6174 21.978C29.6174 19.0639 31.6592 16.6707 34.2434 16.6707C36.8276 16.6707 38.8854 19.0476 38.8694 21.9617C38.8535 24.8759 36.8276 27.269 34.2434 27.269Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDiscord);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/discord.a76af3784dc2e9fbef6d8f4439cdf33e.svg";